export default __webpack_public_path__ + "static/media/globe.947490c6.gif";